import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, forkJoin, map, Observable, of, switchMap } from 'rxjs';
import { History } from 'src/app/history/history';
import { genHttpParams } from 'src/app/_utils/utils';
import { environment } from 'src/environments/environment';
import { IconService } from './icon.service';
import { PraticaAggregator } from '../../settings/header-requests/pratica-aggregator';
import { Account, BEAccount } from '../../../interfaces/account';
import { StatoPratica } from '../../../interfaces/pratica';

@Injectable({
  providedIn: 'root',
})
export class HistoryService {
  private readonly endpointQuery = `${environment.api}/aggregatore-pratica/history/search-pratica-history`;
  private readonly endpointCommand = `${environment.api}/pratica-command/history`;
  constructor(private http: HttpClient, private iconService: IconService) {}

  search(
    page: number,
    size: number,
    filter: any = undefined,
    idPratica: string
  ): Observable<{ items: History[]; total: number }> {
    let params = genHttpParams({ ...history });
    params = params
      .set('page', page)
      .set('size', size)
      .set('orderType', 'DESC')
      .set('idPratica', idPratica);

    return this.http
      .get<{ histories: History[]; total: number }>(this.endpointQuery, {
        params: params,
      })
      .pipe(
        switchMap((res) => {
          return forkJoin(
            res.histories.map((el) =>
              this.iconService.addIcon(
                el.subject,
                'DELIBERA MCC',
                'pratica-states'
              )
            )
          ).pipe(
            map((icons) => ({
              items: res.histories.map((h, i) => ({
                ...h,
                iconName: icons[i],
              })),
              total: res.total,
            }))
          );
        }),
        catchError((err) => of({ items: [], total: 0 }))
      );
  }

  add(history: History) {
    return this.http.post(this.endpointCommand, history);
  }
}
